











import Vue, { PropOptions } from 'vue';

interface ProductSalesPageIncludedEventsProps {
  value: PropOptions;
}

export default Vue.extend({
  name: 'ProductSalesPageIncludedEvents',
  props: {
    value: {
      type: Object as () => ProductSalesPageIncludedEventsResponse,
    },
  } as ProductSalesPageIncludedEventsProps,
  methods: {
    handleOnInput(key: string, value: any): void {
      const emitData = {
        ...this.value,
        [key]: value,
      };
      this.$emit('input', emitData);
    },
  },
});
